var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhysicsNuclearSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD05B"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M246.8,425.6c-44.8,0-79.6-73.6-79.6-167.6c0-94.4,34.8-168,79.6-168s79.6,73.6,79.6,167.6 C326.8,351.6,291.6,425.6,246.8,425.6z M246.8,104.4c-35.6,0-65.6,70.4-65.6,153.2c0,83.2,30,153.2,65.6,153.2 s65.6-70.4,65.6-153.2C312.4,174.8,282.4,104.4,246.8,104.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M151.6,382.8c-16.8,0-29.6-4.8-38.4-13.6c-7.6-8-11.6-19.6-10.8-33.2c2.4-37.6,38.4-90.4,91.6-134.4 c51.2-42.4,108-68.8,148-68.8c16.8,0,29.6,4.8,38.4,13.6c7.6,8,11.6,19.6,10.8,33.2c-2.4,37.6-38.4,90.4-91.6,134.4 C248.4,356.4,191.6,382.8,151.6,382.8z M342,146.8c-36.4,0-90.8,25.6-138.8,65.6c-49.6,41.2-84.4,91.2-86.4,124.4 c-0.4,9.6,1.6,17.2,6.8,22.8c6,6,15.2,9.2,28,9.2c36.4,0,90.8-25.6,138.8-65.6c50-41.2,84.4-91.2,86.4-124.4 c0.4-9.6-1.6-17.2-6.8-22.8C364.4,150,354.8,146.8,342,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342,382.8L342,382.8c-40,0-96.8-26.4-148-68.8c-53.2-44-89.2-96.8-91.2-134.4 c-0.8-13.6,2.8-25.2,10.8-33.2c8.8-9.2,21.6-13.6,38.4-13.6c40,0,96.8,26.4,148,68.8c53.2,44,89.2,96.8,91.6,134.4 c0.8,13.6-2.8,25.2-10.8,33.2C372,378.4,358.8,382.8,342,382.8z M151.6,146.8c-12.8,0-22.4,3.2-28,9.2c-5.2,5.2-7.2,12.8-6.8,22.8 c2,33.2,36.8,83.2,86.4,124.4c48,39.6,102.4,65.6,138.8,65.6l0,0c12.8,0,22.4-3.2,28-9.2c5.2-5.2,7.2-12.8,6.8-22.8 c-2-33.2-36.8-83.2-86.4-124.4C242.4,172.8,188,146.8,151.6,146.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 246.8,
    cy: 257.6,
    r: 27.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7058"
    },
    cx: 218.8,
    cy: 105.6,
    r: 22.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#84DBFF"
    },
    cx: 151.2,
    cy: 375.6,
    r: 22.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4CDBC4"
    },
    cx: 382.4,
    cy: 321.2,
    r: 22.8
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicsNuclearSvgrepoCom);
export default __webpack_public_path__ + "static/media/physics-nuclear-svgrepo-com.74e4460450e277771f73fe6744b1efa2.svg";
export { ForwardRef as ReactComponent };